import React, { useState, useEffect } from 'react'
import TextAreaField from '../../../../../common/utils/textAreaField'

const CARD_DATA = [
  {
    id: 'bucket-strategy-card-1',
    description: 'Longer-term portfolio',
    colorClassName: 'Adele',
    copy: 'The Long-term bucket comprises the majority of retirement assets and is the engine that drives the retirement income strategy. Income can be swept to the other buckets over time to avoid having to make large investment sales. This portfolio emphasizes growth and inflation protection and is invested in a diversified mix of equity, fixed, and other investments.',
  },
  {
    id: 'bucket-strategy-card-2',
    description: 'Medium-term portfolio',
    colorClassName: 'Cher',
    copy: 'Medium-term Investments replenish the Near-term portfolio and are invested to generate a higher yield than cash while still emphasizing stability. We recommend holding 2-4 years of assets invested in income producing securities.',
  },
  {
    id: 'bucket-strategy-card-3',
    description: 'Near-term portfolio',
    colorClassName: 'Beyonce',
    copy: 'The Near-term portfolio provides cash flow for spending in retirement and for unexpected events. We recommend holding cash to cover at least 1-3 years of lifestyle expenses to help avoid selling off investments at inopportune times – such as an extended market downturn.',
  },
]

const App = () => {
  const initialState = ['', '', '']

  const [state, setState] = useState(() => {
    const savedState = localStorage.getItem(`BucketStrategy`)
    return savedState ? JSON.parse(savedState) : initialState
  })

  useEffect(() => {
    localStorage.setItem('BucketStrategy', JSON.stringify(state))
  }, [state])

  const handleStateChange = (index, value) => {
    setState(prev => ({ ...prev, [index]: value }))
  }
  return (
    <div className='BucketInputs--download u-sizeConstrained u-flexRow pt-break-after'>
      <div className='u-marginTop4gu u-flex u-flexJustifyBetween'>
        {CARD_DATA.map((item, index) => (
          <TextAreaField
            name='interest'
            id={item.id}
            key={item.id}
            placeholder='Enter name of accounts(s)'
            label={`My ${item.description.toLowerCase()}`}
            row={2}
            defaultValue={state[index]}
            value={state[index]}
            onChange={e => handleStateChange(index, e.target.value)}
          />
        ))}
      </div>
    </div>
  )
}

export default App
